import React, { useState } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { Steps } from "./step-library"
import { Container, H2, FlexContainer } from "@carrotfertility/carotene"
import { CompleteFormTextArea } from "../../../views/atoms/forms/FormTextArea"
import { useRoutingInfo } from "../../context/RoutingInfoContext"
import ArrowSubmitButton from "../../shared/ArrowSubmitButton"
import { BodySmall } from "../../../views/atoms/Bodies"
import { Skip } from "../../../views/fle/Molecules"
import { useJourneyFlow } from "../../shared/JourneyFlowContainer"

const ViewName = Steps.ANYTHING_ELSE

export default function IsThereAnythingElseStep(): JSX.Element {
  const { routingData, updateRoutingInfo, hasQuestionBeenSkipped } = useRoutingInfo()
  const defaultValue = routingData?.memberJourneyAdditionalInfo
  const { setNextStep } = useStateMachine(
    ViewName,
    defaultValue || hasQuestionBeenSkipped("memberJourneyAdditionalInfo") ? "" : null
  )
  const [text, setText] = useState(defaultValue)
  const { handleContinueLoading, continueLoading } = useJourneyFlow()
  function sanitizeInputs(inputValue) {
    return inputValue === null || inputValue.split("").every((char) => char === " ") || inputValue === ""
      ? null
      : inputValue
  }
  async function onSkip(): Promise<void> {
    await handleContinueLoading(() => updateRoutingInfo({ skipFields: ["memberJourneyAdditionalInfo"] }))
    setNextStep(ViewName, "")
  }
  async function onSubmit(): Promise<void> {
    const sanitizedInput = sanitizeInputs(text)
    if (sanitizedInput === null) {
      await onSkip()
    }
    await handleContinueLoading(() => updateRoutingInfo({ memberJourneyAdditionalInfo: sanitizedInput }))
    setNextStep(ViewName, "")
  }
  function onChange(event) {
    setText((event.target as HTMLInputElement).value)
  }
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
        onSubmit()
      }}
    >
      <Container>
        <H2 stack="tiny">{`Is there anything else you'd like to share?`}</H2>
        <Container stack="large">
          <BodySmall>{`This could include information about your journey to this point, your goals for the future, or any personal or cultural considerations you'd like us to be aware of.`}</BodySmall>
        </Container>
        <CompleteFormTextArea
          {...{
            name: "memberJourneyAdditionalInfo",
            defaultValue: defaultValue,
            maxLength: "3000",
            onChange,
            showValidation: false,
            rows: 4
          }}
        />
        <FlexContainer justifyContent="flex-end">
          {text && text.length >= 3000 * 0.75 && <BodySmall color="black-60">{text.length}/3000</BodySmall>}
        </FlexContainer>
        <FlexContainer paddingTopBottom="huge" justifyContent="space-between">
          <Skip onClick={onSkip} onClickOnly enabled={!continueLoading} />
          <ArrowSubmitButton enabled={!continueLoading}>Continue</ArrowSubmitButton>
        </FlexContainer>
      </Container>
    </form>
  )
}
